import { GenericFilter } from '@/components/GenericFilter';
import type { CountMaterialFilterType, CountMaterialFilterTypeWithValues } from '@shelflix/schemas/material/count';
import { EMaterialStatus } from '@shelflix/schemas/material/enums';

export function DashboardFilter({
  states = [],
  brands = [],
  materials = [],
  onChange,
  isLoading = false,
  ...props
}: {
  states?: string[];
  brands?: string[];
  materials?: string[];
  onChange: (filters: CountMaterialFilterTypeWithValues) => void;
  isLoading?: boolean;
}) {
  const options: CountMaterialFilterType = {
    filter: [
      {
        order: 1,
        label: 'Catálogo de Materiais',
        field: {
          condition: 'equals',
          name: 'material',
        },
        items: [
          ...materials.map((material) => ({
            text: material,
            value: material,
          })),
        ],
      },
      {
        order: 2,
        label: 'Marcas',
        field: {
          condition: 'equals',
          name: 'brand',
        },
        items: [
          ...brands.map((brand) => ({
            text: brand,
            value: brand,
          })),
        ],
      },
      {
        order: 3,
        label: 'Status',
        field: { name: 'status', condition: 'in' },
        items: [
          { text: 'Online', value: [EMaterialStatus.ACTIVE, EMaterialStatus.OPERATIONALONLINE] },
          { text: 'Offline', value: [EMaterialStatus.OFFLINE] },
        ],
      },
      {
        order: 4,
        label: 'Estado',
        field: { name: 'state', condition: 'equals' },
        items: states.map((state) => ({
          text: state,
          value: state,
        })),
      },
    ],
  };

  return <GenericFilter options={options} onChange={onChange} isLoading={isLoading} {...props} />;
}
